module.exports = __webpack_public_path__ + "img/background03.c2c3299b.png";